module.exports = __webpack_public_path__ + "static/media/trator.a80bf01a.svg";